<template>
  <router-link v-if="certificateId"
    :to="{ name: 'CertificateDetailView', params: { certificateId: certificateId } }"
    class="has-text-weight-semibold" style="color: rgb(0, 93, 161)">
    {{ certificateNumber }}
  </router-link>
  <span v-else>{{ certificateNumber }}</span>
</template>
<script>

  export default {
    name: 'certificate-number-cell-component',
    props: {
      certificateNumber: {
        type: String,
        default: ''
      },
      certificateId: {
        type: Number,
        default: null
      }
    }
  }
</script>
